import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useHostCapabilities } from '../hooks/useHostCapabilities';
import type { HostCapabilityKey } from '../utils/hostCapabilities';

/**
 * Spec 014a: a host page this site's brand switched off sends the host back
 * to their cars. While the switches load, the page renders as before.
 * 014b: the brand's admin still opens it (the menu marks it "Admin only").
 */
export function HostCapabilityRoute({
  capability,
  children,
}: {
  capability: HostCapabilityKey;
  children: ReactElement;
}) {
  const { visible, loading } = useHostCapabilities();
  if (!loading && !visible(capability)) {
    return <Navigate to="/cars/host" replace />;
  }
  return children;
}

export default HostCapabilityRoute;
